import React, { useState, useEffect } from 'react'
import { Phone, Mail, MapPin, Clock, Send, CheckCircle2, AlertCircle, Building2 } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'
import Testimonials from './Testimonials'

const TEAM_MEMBERS = [
  {
    name: 'Ceren Kos',
    role: 'Direktør',
    phone: '53 84 33 61',
    email: 'ck@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/2be2c268-1677-4f83-b466-c33802adf32a.png',
    category: 'ledelse',
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'Alexander Peter',
    role: 'Kundechef',
    phone: '53 84 33 61',
    email: 'ap@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/79016566-07c5-408b-8547-f53ebe408ef3.jpg',
    category: 'ledelse',
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'Jane Doe',
    role: 'Økonomichef',
    phone: '53 84 33 61',
    email: 'margit@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/53624d0c-bcc2-49f5-bb82-b258080f2b58.png',
    category: 'ledelse',
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'Jane Doe',
    role: 'HR-chef',
    phone: '53 84 33 61',
    email: 'mh@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/abe6a8ba-716b-4535-bbed-71f32cb6799e.png',
    category: 'ledelse',
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'John Doe',
    role: 'Driftschef - Jylland',
    phone: '53 84 33 61',
    email: 'kp@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/6b27fd71-cdd4-416c-a0ca-f55dacb00964.png',
    category: 'jylland',
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'John Doe',
    role: 'Driftsdirektør - Fyn',
    phone: '53 84 33 61',
    email: 'sn@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/535701de-5bb4-4b08-bb5b-5c84858bfbed.jpg',
    category: 'fyn',
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'Jane Doe',
    role: 'Serviceleder - Fyn',
    phone: '53 84 33 61',
    email: 'okz@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/719dcf65-6bd9-4e19-a53f-91ed5b06743c.png',
    category: 'fyn',
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'John Doe',
    role: 'Serviceleder - Sjælland',
    phone: '53 84 33 61',
    email: 'jbo@wecas.dk',
    image: 'https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/36b9ba2b-0d65-4720-af7e-4e4f5977e634.png',
    category: 'sjaelland',
    linkedin: 'https://linkedin.com'
  }
]

const DEPARTMENTS = [
  {
    name: 'WECAS JYLLAND',
    address: 'Bredstrupvej 40, 7000 Fredericia',
    phone: '53 84 33 61',
    email: 'info@wecas.dk'
  },
  {
    name: 'WECAS FYN',
    address: 'Vestre Stationsvej 15, 5000 Odense C',
    phone: '53 84 33 61',
    email: 'info@wecas.dk'
  },
  {
    name: 'WECAS SJÆLLAND',
    address: 'Gammel Køge Landevej 55, 2500 Valby',
    phone: '53 84 33 61',
    email: 'info@wecas.dk'
  }
]

const getRoleTranslated = (role, lang) => {
  if (lang === 'da') return role
  const rolesMap = {
    'Direktør': 'CEO & Director',
    'Kundechef': 'Head of Customer Relations',
    'Økonomichef': 'CFO & Head of Finance',
    'HR-chef': 'Head of HR',
    'Driftschef - Jylland': 'Operations Manager - Jutland',
    'Driftsdirektør - Fyn': 'Operations Director - Funen',
    'Serviceleder - Fyn': 'Service Manager - Funen',
    'Serviceleder - Sjælland': 'Service Manager - Zealand'
  }
  return rolesMap[role] || role
}

export default function ContactForm({ showFullInfo = true }) {
  const { language, t } = useLanguage()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: 'Erhvervsrengøring',
    message: '',
    website_url: '' // Honeypot field
  })

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      service: language === 'en' ? 'Commercial Cleaning' : 'Erhvervsrengøring'
    }))
  }, [language])

  const [status, setStatus] = useState({
    submitting: false,
    success: false,
    error: null
  })

  const [activeTeamTab, setActiveTeamTab] = useState('alle')

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus({ submitting: true, success: false, error: null })

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })

      if (response.ok) {
        setStatus({ submitting: false, success: true, error: null })
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: 'Erhvervsrengøring',
          message: '',
          website_url: ''
        })
      } else {
        throw new Error('Der opstod en fejl ved afsendelse af formularen. Prøv venligst igen.')
      }
    } catch (err) {
      console.error('Contact form submission error:', err)
      setStatus({
        submitting: false,
        success: false,
        error: err.message || 'Der opstod en netværksfejl. Prøv venligst igen.'
      })
    }
  }

  const filteredTeam = TEAM_MEMBERS

  return (
    <>
    <section id="kontakt" className="relative bg-white py-16 md:py-24 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#a78458]/5 rounded-full blur-3xl -mr-20 -mb-20 pointer-events-none" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12">
        
        {/* Main Contact Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          
          {/* Left Column - Contact Info */}
          <div className="lg:col-span-5">
            <div className="bg-[#FAF8F5] border border-[#E6DFD3] p-6 sm:p-8 mb-8">
              <h2 className="font-marcellus text-2xl sm:text-3xl md:text-4xl font-light tracking-[0.08em] text-[#2C302E] leading-tight mb-6 uppercase">
                {t('contact.title')} <br />
                <span className="font-normal text-[#a78458]">{t('contact.title_gold')}</span> {t('contact.title_end')}
              </h2>
              <p className="text-base text-[#2C302E]/80 leading-relaxed">
                {t('contact.desc')}
              </p>
            </div>

            {/* Contact Details Cards */}
            <div className="divide-y divide-[#E6DFD3] border-t border-[#E6DFD3] my-8">
              {/* Phone */}
              <a
                href="tel:53843361"
                className="flex items-center gap-4 py-5 transition-colors duration-300 hover:text-[#a78458] group"
              >
                <div className="text-[#2C302E] transition-colors duration-300 group-hover:text-[#a78458]">
                  <Phone className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-base font-semibold text-[#2C302E] mt-0.5">53 84 33 61</p>
                  <p className="text-xs text-[#2C302E]/70 font-medium mt-0.5">{language === 'da' ? 'Døgndækket support 24/7' : '24/7 support around the clock'}</p>
                </div>
              </a>

              {/* Email */}
              <a
                href="mailto:info@wecas.dk"
                className="flex items-center gap-4 py-5 transition-colors duration-300 hover:text-[#a78458] group"
              >
                <div className="text-[#2C302E] transition-colors duration-300 group-hover:text-[#a78458]">
                  <Mail className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-base font-semibold text-[#2C302E] mt-0.5">info@wecas.dk</p>
                  <p className="text-xs text-[#2C302E]/70 font-medium mt-0.5">{language === 'da' ? 'Vi svarer hurtigt hele døgnet' : 'We respond quickly all day'}</p>
                </div>
              </a>

              {/* Address */}
              <div className="flex items-center gap-4 py-5">
                <div className="text-[#2C302E]">
                  <MapPin className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-base font-semibold text-[#2C302E] mt-0.5">Bredstrupvej 40, 7000 Fredericia</p>
                  <p className="text-xs text-[#2C302E]/70 font-medium mt-0.5">{language === 'da' ? 'CVR: 45695425 • Centralt placeret for Jylland, Fyn & Sjælland' : 'CVR: 45695425 • Centrally located for Jutland, Funen & Zealand'}</p>
                </div>
              </div>

              {/* Availability */}
              <div className="flex items-center gap-4 py-5">
                <div className="text-[#2C302E]">
                  <Clock className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-base font-semibold text-[#2C302E] mt-0.5">{language === 'da' ? 'Kontakt os 24/7' : 'Contact us 24/7'}</p>
                  <p className="text-xs text-[#2C302E]/70 font-medium mt-0.5">{language === 'da' ? 'Altid klar på telefon eller mail' : 'Always ready on phone or email'}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="lg:col-span-7 bg-white rounded-none border border-[#E6DFD3] p-8 md:p-10 shadow-sm">
            <h3 className="font-marcellus text-2xl font-light text-[#2C302E] mb-2 uppercase tracking-wider">
              {t('detail.get_offer')}
            </h3>
            <p className="text-sm text-[#2C302E]/70 mb-8">
              {t('detail.get_offer_desc')}
            </p>

            {status.success ? (
              <div className="bg-[#a78458]/10 border border-[#a78458]/30 rounded-none p-8 text-center animate-scaleUp">
                <div className="inline-flex h-16 w-16 items-center justify-center rounded-none bg-[#a78458] text-[#FAF8F5] mb-4">
                  <CheckCircle2 className="h-8 w-8" />
                </div>
                <h4 className="font-marcellus text-xl font-light text-[#2C302E] mb-2 uppercase tracking-wider">{language === 'da' ? 'Tak for din henvendelse!' : 'Thank you for your inquiry!'}</h4>
                <p className="text-sm text-[#2C302E]/80 max-w-md mx-auto mb-6">
                  {t('contact.form_success')}
                </p>
                <button
                  onClick={() => setStatus({ submitting: false, success: false, error: null })}
                  className="rounded-none border border-[#a78458] text-[#a78458] hover:bg-[#a78458] hover:text-[#FAF8F5] px-6 py-2.5 text-xs font-semibold tracking-wider uppercase transition-all duration-300 hover:-translate-y-1 hover:scale-[1.03] hover:shadow-md"
                >
                  {language === 'da' ? 'Send en ny besked' : 'Send a new message'}
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                
                {/* Antispam Honeypot Field - ABSOLUTELY HIDDEN from humans */}
                <div className="sr-only absolute" style={{ width: 0, height: 0, overflow: 'hidden' }}>
                  <label htmlFor="website_url">Do not fill this field if you are human</label>
                  <input
                    type="text"
                    id="website_url"
                    name="website_url"
                    value={formData.website_url}
                    onChange={handleChange}
                    tabIndex="-1"
                    autoComplete="off"
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Name */}
                  <div className="flex flex-col gap-1.5">
                    <label htmlFor="name" className="text-xs font-semibold tracking-wider text-[#2C302E] uppercase">
                      {t('contact.form_name')} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={language === 'da' ? 'Dit fulde navn' : 'Your full name'}
                      className="rounded-none border border-[#E6DFD3] bg-[#FAF8F5] px-4 py-3.5 text-sm text-[#2C302E] placeholder-[#2C302E]/40 focus:border-[#a78458] focus:outline-none focus:ring-1 focus:ring-[#a78458] transition-all"
                    />
                  </div>

                  {/* Email */}
                  <div className="flex flex-col gap-1.5">
                    <label htmlFor="email" className="text-xs font-semibold tracking-wider text-[#2C302E] uppercase">
                      {t('contact.form_email')} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      placeholder={language === 'da' ? 'navn@firma.dk' : 'name@company.com'}
                      className="rounded-none border border-[#E6DFD3] bg-[#FAF8F5] px-4 py-3.5 text-sm text-[#2C302E] placeholder-[#2C302E]/40 focus:border-[#a78458] focus:outline-none focus:ring-1 focus:ring-[#a78458] transition-all"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Phone */}
                  <div className="flex flex-col gap-1.5">
                    <label htmlFor="phone" className="text-xs font-semibold tracking-wider text-[#2C302E] uppercase">
                      {t('contact.form_phone')} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder={language === 'da' ? 'Tlf. nummer' : 'Phone number'}
                      className="rounded-none border border-[#E6DFD3] bg-[#FAF8F5] px-4 py-3.5 text-sm text-[#2C302E] placeholder-[#2C302E]/40 focus:border-[#a78458] focus:outline-none focus:ring-1 focus:ring-[#a78458] transition-all"
                    />
                  </div>

                  {/* Company */}
                  <div className="flex flex-col gap-1.5">
                    <label htmlFor="company" className="text-xs font-semibold tracking-wider text-[#2C302E] uppercase">
                      {language === 'da' ? 'Virksomhed / Institution' : 'Company / Institution'}
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder={language === 'da' ? 'Firma ApS' : 'Company Ltd'}
                      className="rounded-none border border-[#E6DFD3] bg-[#FAF8F5] px-4 py-3.5 text-sm text-[#2C302E] placeholder-[#2C302E]/40 focus:border-[#a78458] focus:outline-none focus:ring-1 focus:ring-[#a78458] transition-all"
                    />
                  </div>
                </div>

                {/* Service Dropdown */}
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="service" className="text-xs font-semibold tracking-wider text-[#2C302E] uppercase">
                    {t('contact.form_service')}
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="rounded-none border border-[#E6DFD3] bg-[#FAF8F5] px-4 py-3.5 text-sm text-[#2C302E] focus:border-[#a78458] focus:outline-none focus:ring-1 focus:ring-[#a78458] transition-all appearance-none cursor-pointer"
                    style={{
                      backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%232C302E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 16px center',
                      backgroundSize: '16px'
                    }}
                  >
                    <option value="Erhvervsrengøring">{language === 'da' ? 'Erhvervsrengøring (Kontor, klinik, skole, etc.)' : 'Commercial Cleaning (Office, clinic, school, etc.)'}</option>
                    <option value="Specialrengøring">{language === 'da' ? 'Specialrengøring (Hoved-, flytte-, slutrengøring, etc.)' : 'Specialty Cleaning (Deep, move-out, post-construction, etc.)'}</option>
                    <option value="Byggepladsservice">{language === 'da' ? 'Byggepladsservice (Oprydning, byggerengøring, etc.)' : 'Construction Site Service (Cleanup, post-construction, etc.)'}</option>
                    <option value="Samarbejde">{language === 'da' ? 'Bliv samarbejdspartner / Underleverandør' : 'Become a partner / Subcontractor'}</option>
                    <option value="Andet">{language === 'da' ? 'Andet' : 'Other'}</option>
                  </select>
                </div>

                {/* Message */}
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="message" className="text-xs font-semibold tracking-wider text-[#2C302E] uppercase">
                    {t('contact.form_message')} <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t('contact.form_message_placeholder')}
                    className="rounded-none border border-[#E6DFD3] bg-[#FAF8F5] px-4 py-3.5 text-sm text-[#2C302E] placeholder-[#2C302E]/40 focus:border-[#a78458] focus:outline-none focus:ring-1 focus:ring-[#a78458] transition-all resize-none"
                  />
                </div>

                {/* Error Message */}
                {status.error && (
                  <div className="bg-red-50 border border-red-200 rounded-none p-4 flex items-start gap-3 text-red-800 text-sm animate-fadeIn">
                    <AlertCircle className="h-5 w-5 shrink-0 mt-0.5" />
                    <p>{status.error}</p>
                  </div>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={status.submitting}
                  className="w-full group flex items-center justify-center gap-2 rounded-none bg-[#a78458] py-4 text-sm font-semibold tracking-wider text-[#FAF8F5] uppercase shadow-lg shadow-[#a78458]/20 transition-all duration-300 hover:bg-[#917047] hover:shadow-xl hover:shadow-[#a78458]/30 hover:-translate-y-1.5 hover:scale-[1.01] disabled:bg-[#a78458]/50 disabled:cursor-not-allowed"
                >
                  {status.submitting ? (
                    <>
                      <div className="h-4 w-4 animate-spin rounded-full border-2 border-[#FAF8F5] border-t-transparent" />
                      <span>{t('contact.form_submitting')}</span>
                    </>
                  ) : (
                    <>
                      <span>{t('detail.get_offer')}</span>
                      <Send className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5" />
                    </>
                  )}
                </button>

                <p className="text-[11px] text-[#2C302E]/50 text-center">
                  {language === 'da' 
                    ? 'Ved at indsende denne formular accepterer du, at Wecas ApS må kontakte dig angående dit tilbud. Vi deler aldrig dine oplysninger med tredjeparter.' 
                    : 'By submitting this form, you agree that Wecas ApS may contact you regarding your quote. We never share your information with third parties.'}
                </p>
              </form>
            )}
          </div>

        </div>
      </div>
    </section>
    <Testimonials />
    </>
  )
}
